import { Box, Grid, GridProps } from "@mui/material";
import { GetProductResponse } from "src/models/product";

type FreightDetailsProps = GridProps & {
  product: GetProductResponse;
  showTitle?: boolean;
};

export const FreightDetails: React.FC<FreightDetailsProps> = ({
  product,
  showTitle,
  ...rest
}: FreightDetailsProps) => {
  return (
    <>
      {showTitle && (
        <Box component="h3" marginBottom={(theme) => `${theme.spacing(1)} !important`}>
          Freight
        </Box>
      )}

      <Grid container {...rest}>
        <Grid item xs={5} className="last">
          Cost
        </Grid>
        <Grid item xs={7} className="last">
          {product.freightPrice != null ? `$${product.freightPrice}` : null}
        </Grid>
      </Grid>
    </>
  );
};
